import moment from "moment";
export default {
  id: "balance",
  type: "balance",
  icon: "balance-scale-right",
  text: "Bilancio contabile",
  detailsText: "Dettagli bilancio contabile",
  detailParams: ["fromDate", "toDate", "accountId"],
  mainParams: ["refYear", "fromDate", "toDate"],
  header: {
    rows: [
      {
        type: "row",
        items: [
          {
            type: "dropdown",
            id: "refYear",
            label: "Anno di riferimento",
            range: { min: moment().format("YYYY"), max: moment().subtract(10, "years").format("YYYY") },
            initValue: moment().format("YYYY"),
            updateRangeDateId: ["fromDate", "toDate"]
          },
          {
            type: "rangedate",
            id: ["fromDate", "toDate"],
            label: "Seleziona periodo",
            initValue: [moment("01/01/" + moment().format("YYYY")), moment("12/31/" + moment().format("YYYY"))]
          }
        ]
      },
      {
        type: "row",
        items: [
          {
            type: "toggle",
            id: "mode",
            label: "Visualizza situazione contabile per competenza",
            initValue: false
          }
        ]
      }
    ]
  },
  groupBy: ["balanceSheet", "incomeStatement"]
};
